// Lyrics panel above the timeline — readable + scrollable while recording.
// Pure UI: never touches the audio engine, playhead or recorder.
import React from "react";
import { ChevronDown, ChevronUp, PenLine } from "lucide-react";

export function LyricsPanel({ lyrics, expanded, onToggle, onEdit, recording }) {
  const has = !!(lyrics || "").trim();
  return (
    <section className={`mb-2 rounded-xl border ${recording ? "border-red-400/40" : "border-white/10"} bg-[#0f0b1a]`} data-testid="studio-lyrics-panel">
      <div className="flex items-center gap-2 px-3 h-10">
        <button type="button" onClick={onToggle} className="flex items-center gap-1.5 flex-1 text-left min-w-0" aria-expanded={expanded} data-testid="lyrics-panel-toggle-btn">
          {expanded ? <ChevronUp className="w-4 h-4 text-fuchsia-300" /> : <ChevronDown className="w-4 h-4 text-fuchsia-300" />}
          <span className="text-[11px] uppercase tracking-widest font-bold text-fuchsia-200">Lyrics</span>
          {!expanded && has && <span className="text-[11px] text-gray-500 truncate">{lyrics.trim().split("\n")[0]}</span>}
        </button>
        {onEdit && <button type="button" onClick={onEdit} className="flex items-center gap-1 text-[11px] font-bold text-gray-300 hover:text-white px-2 py-1 rounded-full border border-white/15" data-testid="lyrics-panel-edit-btn">
          <PenLine className="w-3.5 h-3.5" />{has ? "Edit" : "Write"}
        </button>}
      </div>
      {expanded && (
        <div className="max-h-[32vh] overflow-y-auto px-4 pb-4 whitespace-pre-wrap text-white/95"
          style={{ overscrollBehavior: "contain", WebkitOverflowScrolling: "touch", touchAction: "pan-y", fontSize: "18px", lineHeight: "1.65" }}
          data-testid="lyrics-panel-text">
          {has ? lyrics : <span className="text-gray-500 text-sm">No lyrics yet{onEdit ? " — tap Write to add them." : "."}</span>}
        </div>
      )}
    </section>
  );
}
